import React, { useEffect, useState } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';
import { supabase } from './supabaseClient';
import defaultUser from './user-default.png';

function UserProfile({ userId, setPage }) {
  const [user, setUser] = useState(null);
  const [availability, setAvailability] = useState(null);
  const showAvailability = true;
  const weekdayOrder = [
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
    'Sunday',
  ];

  useEffect(() => {
    if (!userId) return;

    const loadUser = async () => {
      const userDoc = await getDoc(doc(db, 'users', userId));
      if (!userDoc.exists()) return;

      const userData = userDoc.data();
      const { data: supa } = supabase.storage
        .from('profile-pictures')
        .getPublicUrl(`profile-pictures/${userId}/profile.jpg`);
      const photoURL = supa?.publicUrl || defaultUser;

      setUser({ ...userData, photoURL });

      const availDoc = await getDoc(doc(db, 'availability', userId));
      if (availDoc.exists()) {
        setAvailability(availDoc.data());
      }
    };

    loadUser();
  }, [userId]);

  const formatTime = (time) => {
    const [hour, minute] = time.split(':').map(Number);
    const ampm = hour >= 12 ? 'PM' : 'AM';
    const hour12 = hour % 12 || 12;
    return `${hour12}:${minute.toString().padStart(2, '0')}${ampm}`;
  };

  const sortedSlots = availability?.slots
    ? [...availability.slots].sort(
        (a, b) => weekdayOrder.indexOf(a.day) - weekdayOrder.indexOf(b.day)
      )
    : [];

  if (!user) return <p style={{ padding: 40, fontSize: 24 }}>Loading user profile...</p>;

  return (
    <div style={{
      padding: 40,
      maxWidth: 800,
      margin: '0 auto',
      fontFamily: 'Arial, sans-serif',
    }}>
      <button
        onClick={() => setPage('connections')}
        style={{
          marginBottom: 30,
          padding: '10px 20px',
          fontSize: 16,
          backgroundColor: '#007BFF',
          color: 'white',
          border: 'none',
          borderRadius: 6,
          cursor: 'pointer'
        }}
      >
        ← Back
      </button>

      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          background: '#f9f9f9',
          borderRadius: 16,
          padding: 30,
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)'
        }}
      >
        <img
          src={user.photoURL}
          alt="Profile"
          style={{
            width: 150,
            height: 150,
            borderRadius: '12%',
            objectFit: 'cover',
            marginRight: 30,
            backgroundColor: '#ddd',
          }}
        />
        <div style={{ flex: 1, color: 'black', }}>
          <h1 style={{ margin: 0, fontSize: 32 }}>{user.fullName || 'Anonymous User'}</h1>
          {user.role && (
            <p style={{ fontSize: 18, marginTop: 10 }}>
              <b>Role:</b> {user.role}
            </p>
          )}
          {user.bio && (
            <p style={{ fontSize: 16, marginTop: 10, color: '#444' }}>
              <b>Bio:</b> {user.bio}
            </p>
          )}
        </div>
      </div>

      <div style={{ marginTop: 40, backgroundColor: 'rgb(249, 249, 249)', padding: '12px', borderRadius: '12px', border: '0px',}}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h2 style={{ fontSize: 24, color: 'black', }}>Availability</h2>
          {/* <button
            onClick={() => setShowAvailability(!showAvailability)}
            style={{
              fontSize: 14,
              backgroundColor: '#eee',
              border: '1px solid #ccc',
              padding: '6px 12px',
              borderRadius: 4,
              cursor: 'pointer'
            }}
          >
            {showAvailability ? 'Hide' : 'Show'}
          </button> */}
        </div>

        {showAvailability && (
          sortedSlots.length > 0 ? (
            <ul style={{
              listStyle: 'none',
              paddingLeft: 0,
              marginTop: 20,
              fontSize: 16,
              lineHeight: '1.8em',
              color: '#333'
            }}>
              {sortedSlots.map((slot, i) => (
                <li key={i}>
                  <b>{slot.day}:</b> {formatTime(slot.from)} – {formatTime(slot.to)}
                </li>
              ))}
            </ul>
          ) : (
            <p style={{ color: '#777', fontSize: 16, marginTop: 10 }}>
              This user hasn't set their availability.
            </p>
          )
        )}
      </div>
    </div>
  );
}

export default UserProfile;
